const LOCAL_STORAGE = {
  KEY: 'tasks',
};

export default LOCAL_STORAGE;
